import React from 'react'
import FormControlBase from "./FormControl";
import '../../../assets/sass/global/input-fields.scss';

const classNames = require('classnames');

class InputFieldBase extends FormControlBase {
    render = () => {
        const sizeClass = this.getSizeFromProps();
        const componentClass = this.getComponentClassName();

        return (
            <div className={classNames(componentClass, sizeClass)}>
                {this.renderContent()}
            </div>
        );
    };


    getComponentClassName = () => 'input-field';
}


export default InputFieldBase;
